import { connect } from 'react-redux';

import { requestPasswordAction, setMessage } from '../actions/userActions';
import ForgotPasswordView from '../components/User/ForgotPassword/forgotPasswordView.jsx';
import {
  getErrors,
  getLoading,
  getMessage,
  getSuccessful,
} from '../components/User/userSelectors';

const mapStateToProps = (state) => ({
  errors: getErrors(state),
  successful: getSuccessful(state),
  message: getMessage(state),
  isLoading: getLoading(state),
});

const mapDispatchToProps = (dispatch) => ({
  requestPassword: (email) => {
    dispatch(requestPasswordAction(email));
  },
  setMessage: (value) => {
    dispatch(setMessage(value));
  },
});

const ForgotPasswordContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ForgotPasswordView);

export default ForgotPasswordContainer;
